module.exports = __webpack_public_path__ + "img/38.cc1247cc.jpg";